import { FieldInterface } from 'common/types/entities/field-interface'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import BaseFieldNew from 'publisher/components/entities/field-new/base-field'
import { usePayment } from 'publisher/store'
import paymentSelectors from 'publisher/store/payment/paymentSelectors'
import React from 'react'

interface CompanyVatFieldProps {
  entity: FieldInterface
}

const CompanyVatFieldNew = ({ entity }: CompanyVatFieldProps) => {
  const isPersonal = usePayment(paymentSelectors.isCustomerPersonal)

  if (typeof window === 'undefined') {
    return (
      <StyleWrapper
        margin={entity.margin}
        mobileMargin={entity.mobileMargin}
        appearance={entity.appearance}
      />
    )
  }

  return isPersonal ? <div /> : <BaseFieldNew entity={entity} />
}

export default CompanyVatFieldNew
